import Axios from "axios";
import Firebase from "./firebase";

// init number of axios requests retried to 0.
sessionStorage.setItem("numOfRetry", 0);

// axios wrapper for requests to FLAPI.
export const axiosWrapper = async ({ method, url, params, data }) => {
	if (!["get", "post", "put", "patch", "delete"].includes(method)) throw new Error("Unknown method");
	try {
		const token = sessionStorage.token || (await Firebase.getUserToken());
		const baseURL = process.env.REACT_APP_FLAPI_SERVER;
		const headers = { Authorization: `Bearer ${token}` };
		return Axios({ method, baseURL, url, params, data, headers });
	} catch (e) {
		console.error("axiosWrapper", e.message || e);
		throw e;
	}
};

// create an axios interceptor for when 401|403 IS received
Axios.interceptors.response.use(
	(successResponse) => {
		// if request was successful - allow retry on future requests.
		sessionStorage.setItem("numOfRetry", 0);
		return successResponse;
	},
	async (error) => {
		// handle 401/403
		if (error.response?.status === 401 || error.response?.status === 403) {
			try {
				const newToken = await Firebase.refreshToken();
				sessionStorage.setItem("token", newToken);
				// if no request retry was made mark a retry is being made and retry.
				if (sessionStorage.getItem("numOfRetry") === "0") {
					sessionStorage.setItem("numOfRetry", 1);
					return axiosWrapper({ method: error.config.method, url: error.config.url, data: error.config.data });
				}
			} catch (err) {
				throw err;
			}
		}
		throw error.response;
	}
);
